var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleEuro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 60,
    viewBox: "0 0 77 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1606_1485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7558 4.51503L4.93167 22.3391C0.708245 26.5626 0.708245 33.4101 4.93167 37.6335L22.7558 55.4576C26.9792 59.681 33.8267 59.681 38.0501 55.4576L55.8743 37.6335C60.0977 33.4101 60.0977 26.5626 55.8743 22.3392L38.0501 4.51504C33.8267 0.291615 26.9792 0.291612 22.7558 4.51503Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7558 4.51503L4.93167 22.3391C0.708245 26.5626 0.708245 33.4101 4.93167 37.6335L22.7558 55.4576C26.9792 59.681 33.8267 59.681 38.0501 55.4576L55.8743 37.6335C60.0977 33.4101 60.0977 26.5626 55.8743 22.3392L38.0501 4.51504C33.8267 0.291615 26.9792 0.291612 22.7558 4.51503Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5847 22.722V37.2782C20.5847 38.6809 21.7218 39.818 23.1245 39.818H37.6807C39.0834 39.818 40.2205 38.6809 40.2205 37.2782V22.722C40.2205 21.3192 39.0834 20.1821 37.6807 20.1821H23.1245C21.7218 20.1821 20.5847 21.3192 20.5847 22.722Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.937 55.4666C43.17 59.6996 50.0248 59.6996 54.2578 55.4666L72.0639 37.6605C74.1668 35.5576 75.2319 32.7993 75.2319 30.0137C75.2319 27.2554 74.1668 24.4697 72.0639 22.3669L54.2578 4.56077C50.0248 0.327725 43.17 0.327725 38.937 4.56077",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1606_1485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.1948,
    height: 60,
    fill: "white",
    transform: "translate(0.402588)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleEuro);
export default __webpack_public_path__ + "static/media/doubleEuro.4e2d3b40b24f57b5ef462f6b3a82a3be.svg";
export { ForwardRef as ReactComponent };